import * as clsApi from "./classroomApi";

export async function getBhsHistory(studentEmail, startDate, endDate) {
	const res = await clsApi.Get(
		`browsing-history-service/history/${studentEmail}?start=${encodeURIComponent(startDate.format())}&end=${encodeURIComponent(
			endDate.format()
		)}`
	);
	return res;
}

export async function getBhsScreenshot(fileName) {
	const res = await clsApi.fetchWithType(`browsing-history-service/screenshot?filename=${encodeURI(fileName)}`, "blob");
	return res;
}

export async function getBhsScreenshotZip(studentEmail, startDate, endDate, url) {
	const res = await clsApi.fetchWithType(
		`browsing-history-service/screenshot/${studentEmail}/zip
		?start=${encodeURIComponent(startDate.format())}&end=${encodeURIComponent(endDate.format())}&url=${encodeURIComponent(url)}`,
		"download"
	);
	return res;
}
